// extracted by mini-css-extract-plugin
module.exports = {"mobileWrapper":"ResetPassword_mobileWrapper__3Z0p4","action":"ResetPassword_action__2bc-b","success":"ResetPassword_success__YKVXl"};